import axios from 'axios';
export default class HttpService {
    // Método GET genérico
    static get(url, params = {}) {
        return axios.get(url, { params });
    }
    // Método POST genérico
    static post(url, data) {
        return axios.post(url, data);
    }
}
